<template>
	<v-container grid-list-lg>
		<v-layout row wrap>		
			<v-flex lg12 class="userInfo">								
				<div class="section">
					<h2>Region Info</h2>
					<table width="100%">						
						<tr>
							<td width="25%" valign="top"><strong>Regions:</strong></td>
							<td v-html="fncSplitObject( objUserInfo.user_locations )"></td>
						</tr>						
					</table>
				</div>
			</v-flex>			
			<div class="pl-4 pr-2 pb-4 buttonHolder">
				<div style="float: right">
					<v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>					
				</div>	
			</div>							
		</v-layout>
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex'; 	
	export default {
	  name: 'Settings',
	  data () {
			return {	
				objUser: 0,
				userTypes: {
				    1: 'Manufacturer',
					2: 'Customer',
					3: 'Specific',
					4: 'Public'
				},
				userRegions: ''
			};
		},		
		methods: {
			fncHideModal () {
				this.$store.commit('hideModal');
			},
            fncSplitObject( splitObj ) {
			    var toReturn = '';
                for (var key in splitObj) {
                    toReturn += splitObj[key] + "<br />";
                }
                return toReturn.substring(0, toReturn.length - 1);
			},
            fncGetUserPricelists( pricelistObj ) {
			    this.$store.dispatch({
					type: 'fncGetUserPricelists',
					pricelists: pricelistObj
				});
			}
		},
		computed: {
			...mapGetters([
				'objAuthorize',					
				'globalModalParams',
				'objUserInfo',
			])
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>